// extracted by mini-css-extract-plugin
var _1 = "aPgzc";
export { _1 as "base" }
